import { base, loggedOut, WizardLayout } from '@/layouts'
import Login from '@/views/Login'

import { requiresAuth, logout } from '@/lib/auth.js'

export default [ 
  {
    path: '/login',
    component: loggedOut,
    children: [
      {
        name: 'login',
        path: '',
        component: Login,    
      },
      {
        name: 'login/accept',
        path: 'accept',
        component: () => import('@/views/Login/Accept'),
      },
      {
        name: 'login/claim',
        path: 'claim/:id(\\d+)',
        props: true,
        component: () => import('@/views/Login/Claim'),
      },
      {
        name: 'login/eula',
        path: 'eula',
        component: () => import('@/views/Login/EULA'),
      },
      {
        name: 'login/privacy',
        path: 'privacy',
        component: () => import('@/views/Login/Privacy'),
      },
      {
        name: 'login/welcome',
        beforeEnter: requiresAuth,
        path: 'welcome',
        component: () => import('@/views/Login/Welcome'),
      },
    ]
  },
  { path: '/qr', redirect: '/link' },
  {
    path: '/link',
    component: base,
    children: [
      {
        name: 'qr',
        path: '',
        component: () => import('@/views/QR'),    
      },
      {
        name: 'qr/confirmation',
        path: 'confirmation',
        component: () => import('@/views/QR/Confirmation'),    
      },
      {
        name: 'qr/wizard/category',
        path: 'category',
        component: () => import('@/views/QR/Wizard/Category'),    
      },
      {
        path: 'wizard',
        component: WizardLayout,
        children: [
          {
            name: 'qr/wizard/contact',
            path: 'contact',
            component: () => import('@/views/QR/Wizard/Contact'),    
          },
          {
            name: 'qr/wizard/notes',
            path: 'notes',
            component: () => import('@/views/QR/Wizard/Notes'),    
          },
          {
            name: 'qr/wizard/property',
            path: 'property',
            component: () => import('@/views/QR/Wizard/Property'),    
          },
          {
            name: 'qr/wizard/service',
            path: 'service',
            component: () => import('@/views/QR/Wizard/Service'),    
          },
          {
            name: 'qr/wizard/verify',
            path: 'verify',
            component: () => import('@/views/QR/Wizard/Verify'),    
          },
        ],
      },
    ]
  },
  {
    path: '/recover',
    component: loggedOut,
    children: [
      {
        name: 'recover',
        path: '',
        component: () => import('@/views/Recover'),    
      },
      {
        name: 'recover/methods',
        path: 'methods',
        component: () => import('@/views/Recover/Methods'),
      },
      {
        name: 'recover/verify',
        path: 'verify',
        component: () => import('@/views/Recover/Verify'),
      },
      {
        path: 'verify/:id(\\d+)',
        props: true,
        component: () => import('@/views/Recover/Verify'),
      },
    ]
  },
  {
    name: 'logout',
    path: '/logout',
    beforeEnter: logout,
  },    
]